
import React from "react";
import {ReactComponent as palletIcon} from './icons8-pallet-24.svg';
import SvgIcon from "@material-ui/core/SvgIcon";


const PressPalletIcon = () => (<SvgIcon component={palletIcon} />);

export default PressPalletIcon;
